import { PageContainer } from './ActivitiesPage.styles';
import { Headers, Spacer } from '@tw/tw-component-library';
import {
  ContentSectionContainer,
  ContentSection,
} from '../askHub/AskHub.styles';
import { FilterPills } from '@/components/common/Activities/ActivitiesPage/components/FilterPills';
import { ActivityMenu } from '@/components/common/Activities/ActivityMenu';
import { useAuditLogActivities } from '@/components/common/Activities/ActivitiesPage/hooks/useAuditLogActivities';
import { Wrapper } from '@/components/common/Activities/ActivityMenu/styles/styled';
import { WorkspaceHeaderLayout } from '@/components/layout/WorkspaceHeaderLayout';
import { UseAuth } from '@/contexts/AuthContext';
import { transformAllUserWorkspaces, TransformedUserWorkspace } from '@/utils/data/transformWorkSpaceItems';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getWorkspace } from '@/apis/core/workspace/get/getWorkspace';

export const ActivitiesPage = () => {
  const { id } = useParams<{ id: string }>();
  const { getAccessToken } = UseAuth();
  const [workspaceData, setWorkspaceData] = useState<TransformedUserWorkspace | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const {
    loading,
    visibleActivities,
    isLoadingMore,
    hasMore,
    activityFilter,
    setActivityFilter,
    typeFilter,
    setTypeFilter,
    userFilter,
    setUserFilter,
    workspaceUserOptions,
    fetchMoreActivities,
    totalActivities,
  } = useAuditLogActivities(
    workspaceData
      ? {
          fetchActivities: true,
          workspaceUserData: workspaceData.workspaceUsers?.userData,
          workspaceId: id || '',
        }
      : undefined
  );

    const getWorkspaceData = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await getWorkspace({
        getAccessToken: getAccessToken,
        workspaceId: id || '',
      });

      const transformed = await transformAllUserWorkspaces(
        [data],
        getAccessToken
      );
      setWorkspaceData(transformed[0]);
    } catch (err) {
      const error =
        err instanceof Error ? err : new Error('Failed to load workspace data');
      setError(error);
      console.error('Failed to load workspace data:', error);
    } finally {
      setIsLoading(false);
    }
  }, [id, getAccessToken]);

  useEffect(() => {
    getWorkspaceData();
  }, [getWorkspaceData]);

  return (
    <PageContainer>
      {!isLoading && !error && (
        <>
          <WorkspaceHeaderLayout
            workspaceData={workspaceData as TransformedUserWorkspace}
            activePage="activities"
          />
        

      <ContentSectionContainer>
        <ContentSection>
          <Wrapper>
            <Headers headerType="h2">Activities ({totalActivities})</Headers>
            <Spacer />
            <Headers headerType="caption">Last 30 days</Headers>
            <Spacer />
            <FilterPills
              currentActionFilter={activityFilter}
              onActionFilterChange={setActivityFilter}
              currentTypeFilter={typeFilter}
              onTypeFilterChange={setTypeFilter}
              currentUserFilter={userFilter}
              onUserFilterChange={setUserFilter}
              userOptions={workspaceUserOptions}
            />
            <Spacer />
            <ActivityMenu
              activities={visibleActivities}
              isLoading={loading}
              maxHeight="endless"
              emptyStateMessage="No activities available"
              view="fullPage"
              onLoadMore={fetchMoreActivities}
              hasMore={hasMore}
              isLoadingMore={isLoadingMore}
            />
          </Wrapper>
        </ContentSection>
          </ContentSectionContainer>
        </>
      )}
    </PageContainer>
  );
};
